module.exports = __webpack_public_path__ + "static/media/m4.31c43bb3.png";